import $ from 'jquery'

export const setupSelectLinks = () => {
  const container = $(".select-links");
  const links = container.find(">div");
  const a = container.find(">a");
  const cssClass = "opened";
  const hide = () => {
    links.hide();
    a.removeClass(cssClass);
    links.removeClass(cssClass);
  };
  const show = () => {
    links.show();
    a.addClass(cssClass);
    links.addClass(cssClass);
  };
  a.on("click", function(e) {
    e.preventDefault();
    if (a.hasClass(cssClass)) {
      hide();
    } else {
      show();
    }
  });
  $(document).on("mouseup", e => {
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      hide();
    }
  });
};
